import loop54 from '~/lib/api/loop54';
import { Loop54Types } from '~/lib/data-contract';
import loop54Errors from '~/services/loop54/errors';
import { getUrl } from '~/services/loop54/utils';

export default function getEntitiesByAttribute(
    params: Loop54Types.GetEntitiesByAttributeRequest | undefined,
) {
    if (!params) {
        return Promise.reject(new Error(loop54Errors.missingParams.message));
    }

    return loop54
        .post(getUrl('/getEntitiesByAttribute'), {
            json: params,
        })
        .json<Loop54Types.GetEntitiesByAttributeResponse>();
}
